import type { AppAuthProvider } from './types';

export const resolveAuthProvider = (
  configuredProvider: string | undefined
): AppAuthProvider => {
  const provider = configuredProvider?.trim().toLowerCase() || 'cognito';
  if (provider === 'cognito' || provider === 'supabase') return provider;
  throw new Error(`Unsupported authentication provider: ${provider}`);
};
